import React, { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PrivateRoutes from './PrivateRoutes';
import PublicRoutes from './PublicRoutes';
import { path } from '../constants';
import TwoFAAccountVerification from '../pages/2fa';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import TermsAndCondition from '../pages/TermsAndCondition';

const Loader = lazy(() => import('../components/Loader'));
const Login = lazy(() => import('../pages/Login'));
const Create = lazy(() => import('../pages/Create/index'));
const Create2 = lazy(() => import('../pages/Create copy/index'));
const CreateIBW = lazy(() => import('../pages/Create copy 2/index'));


const ChangePasswordScreen = lazy(() => import('../pages/ChangePassword'));
const PersonalInfo = lazy(() => import('../pages/PersonalInfo'));
const EditPersonalInfo = lazy(() => import('../pages/EditPersonalInfo'));
const KalpProducts = lazy(() => import('../pages/KalpProducts'));
const Subscription = lazy(() => import('../pages/Subscription'));
const KalpWallet = lazy(() => import('../pages/KalpWallet'));
const Transactions = lazy(() => import('../pages/Transaction'));
const Settings = lazy(() => import('../pages/Settings'));
const PasswordUpdate = lazy(() => import('../pages/PasswordUpdate'));
const Redirection = lazy(() => import('../pages/Redirection'));

const AppRoutes = () => {
  const LandingPage = () => {
    return <Navigate to={path.LOGIN} />;
  };

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route element={<PrivateRoutes />}>
          <Route path={path.PERSONAL_INFO} element={<PersonalInfo />} />
          <Route
            path={path.EDIT_PERSONAL_INFO}
            element={<EditPersonalInfo />}
          />
          <Route path={path.KALP_PRODUCTS} element={<KalpProducts />} />
          {/* <Route path={path.SUBSCRIPTION} element={<Subscription />} /> */}
          {/* <Route path={path.CREDIT} element={<KalpWallet />} /> */}
          {/* <Route path={path.TRANSACTION} element={<Transactions />} /> */}
          <Route path={`${path.SETTINGS}/:tab?`} element={<Settings />} />
          <Route path={path.PASSWORD_UPDATE} element={<PasswordUpdate />} />
        </Route>
        <Route element={<PublicRoutes />}>
          <Route path={path.ROOT} element={<LandingPage />} />
          <Route path={path.LOGIN} element={<Login />} />
          <Route
            path={path.SIGN_UP}
            element={<Create />}
          />
          <Route path={path.SIGN_UP_IBW}  element={<Navigate to={path.SIGN_UP} />} /> 
           <Route path={path.SIGN_UP_NEW} element={<Navigate to={path.SIGN_UP} />} />

          <Route
            path={path.CHANGE_PASSWORD}
            element={<ChangePasswordScreen />}
          />
          <Route path={path.TWOFA} element={<TwoFAAccountVerification />} />
        </Route>
        <Route path={path.PRIVACY_POLICY} element={<PrivacyPolicy />} />
        <Route
          path={path.TERMS_AND_CONDITIONS}
          element={<TermsAndCondition />}
        />
        <Route path={path.REDIRECTION} element={<Redirection />} />
      </Routes>
    </Suspense>
  );
};
export default AppRoutes;
